import type { Subscription } from '../types';

import { hasFreeDevPlan } from './hasFreeDevPlan';
import { hasPlan } from './hasPlan';

/**
 * True when the subscription has a paid plan. Excludes the free dev plan (Developer2025).
 */
export function hasPaidPlan(subscription: Subscription | null | undefined) {
  return !!(subscription && hasPlan(subscription) && !hasFreeDevPlan(subscription));
}
